export const SET_SELECTED_TEAM = 'SET_SELECTED_TEAM'
export const SET_SELECTED_DATABOX = 'SET_SELECTED_DATABOX'
export const SET_DATABOX_DOCUMENTS = 'SET_DATABOX_DOCUMENTS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_TEAM_TAGS = 'SET_TEAM_TAGS'
